import { graphql } from 'gatsby';
import React from 'react';

import Default from '~/templates/Default';

import Seo from '~/layout/SEO';

import { useUser } from '~/context/UserContext';

import BlockList from '~/components/BlockList';
import Redirect from '~/components/Redirect';
import Loader from '~/components/Loader';

import { useAccountPaths } from '~/account/hooks/useAccountPaths';

import RewardsContextProvider from '~/account/context/RewardsContext';

const AccountPage = ({ data }) => {
    const { isLoggedIn, loading } = useUser();
    const accountPaths = useAccountPaths();

    const {
        wpAccountPage: {
            blocks,
            template: { templateName }
        }
    } = data;

    if (!isLoggedIn && templateName === 'Authorized Route') {
        return loading ? (
            <Default>
                <Loader />
            </Default>
        ) : (
            Redirect(accountPaths.login)
        );
    }

    return (
        <Default>
            <RewardsContextProvider>
                <BlockList {...{ blocks }} />
            </RewardsContextProvider>
        </Default>
    );
};

export default AccountPage;

export const Head = ({
    location,
    data: {
        wpAccountPage: { seo: seoFragment }
    }
}) => <Seo {...{ location, seoFragment }} />;

export const query = graphql`
    query Page($id: String!) {
        wpAccountPage(id: { eq: $id }) {
            id
            title
            seo {
                ...SeoFragment
            }
            blocks {
                ...BlockListFragment
            }
            template {
                templateName
            }
        }
    }
`;
